import React from 'react';

import {
  GenericPaginatedList,
  GenericPaginatedListCommonProps,
} from 'app/components/general/lists/GenericPaginatedList';
import {StoredSignoffFetcher} from 'app/signoffs/datafetchers';

import {TeamSignoffsListItem} from './TeamSignoffsListItem';

import {TeamSerializedType} from 'sweet-types';

import type {SignoffTemplateLocationParamsType} from 'app/signoffs/types';

type Props =
  GenericPaginatedListCommonProps<SignoffTemplateLocationParamsType> & {
    team: TeamSerializedType;
    groupedBy: 'doc' | 'user';
  };

export const TeamSignoffsList = ({
  team,
  noItemsMessage,
  paramsBuilder,
  pageParamName,
  loadingListProps,
  groupedBy,
}: Props) => (
  <GenericPaginatedList
    ItemComponent={TeamSignoffsListItem}
    FetcherComponent={StoredSignoffFetcher}
    noItemsMessage={noItemsMessage}
    paramsBuilder={paramsBuilder}
    customProps={() => ({
      team,
      groupedBy,
    })}
    pageParamName={pageParamName}
    loadingListProps={loadingListProps}
  />
);
